<div class="radio-wrapper" [ngClass]="{ required: markAsRequired, valid: markAsValid }">
	<label class="col-form-label"
		>{{ groupHeading }} <br *ngIf="groupSubHeading" />
		<small *ngIf="groupSubHeading">{{ groupSubHeading }}</small>
	</label>
	<div class="input-field" [ngClass]="{ 'is-invalid': isInvalid(control) }">
		<ng-content></ng-content>
		<span [ngClass]="{ 'is-invalid': isInvalid(control) }"></span>
		<ng-container *ngIf="isInvalid(control)">
			<div class="error-message">
				<small *ngIf="inputErrors(control, 'required')" class="text-danger">
					<span>{{ 'inputRadioWrapper.selectionRequired' | translate }}</span
					>.
				</small>
			</div>
		</ng-container>
	</div>
</div>
